<template>
    <!--页脚导航-->
    <footer class="index_footer">
      <div class="index_footer_layout">
        <div class="in_footer_top">
          <div class="footer_logo" @click="toHome"><img src="../../../assets/img/kslogo.png"></div>
          <div class="footer_nav">
            <div  @click="headerClick('aboutus')">关于我们</div>
            <div  @click="headerClick('society')">社会责任</div>
            <div  @click="headerClick('news')">新闻动态</div>
            <div  @click="headerClick('InvestorRelations')">投资者关系</div>
            <div  @click="headerClick('joinus')">加入我们</div>
          </div>
          <div class="footer_follow">
            <div class="follow_title">关注我们</div>
            <i class="iconfont icon-website-weixin" @click.stop="showWX=!showWX"></i>
            <i class="iconfont icon-website-weibo" @click="openLink('https://weibo.com/u/1298306070/')"></i>
            <!--<i class="iconfont icon-website-yutube"></i>-->
            <!--二维码弹窗-->
            <div class="footer_erweima" v-show="showWX">
              <img src="../../../assets/img/weixin.jpg">
            </div>
          </div>
        </div>
        <div class="in_footer_company">
          <div @click="openLink('https://www.wps.cn/')">金山办公</div>
          <div @click="openLink('https://www.xishanju.com/')">西山居</div>
          <div @click="openLink('https://www.seayoo.com/')">金山世游</div>
          <div @click="openLink('https://www.ksyun.com/')">金山云</div>
          <div @click="openLink('https://www.cmcm.com/')">猎豹移动</div>
        </div>
        <div class="in_footer_copyright">
          <span>Copyright ©2008-2024 Kingsoft, All Rights Reserved. 北京金山数字娱乐科技有限公司 版权所有</span>
        </div>
        <div class="in_footer_copyright">
          <span @click="openPlice">京公网安备11010802025727（总）</span>      
          <span @click="openNetAcc">网出证（京）字第168号</span>      
          <!--<span @click="openNetWrite">京网文【2014】0937-238号</span>-->      
          <span @click="openICP">京ICP备06025896-1号</span>
          <span @click="openPrivate">隐私政策</span>
          <span @click="openAccept"><img src="../../../assets/img/kxlogo.png"></span>
        </div>
        <div class="backup hvr-hang" @click="goTop" v-show="isShowTop">
          <i class="iconfont icon-website-backup"></i>
        </div>
      </div>
    </footer>
</template>


<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import store from '../../../store'
export default {
  name: 'footerBuild',
  components:{},
  props: {
    
  },

  data () {
    return {
      offsetHeight:400,
      showWX:false,
      tHeight:0,
      isShowTop:false
    }
  },
  computed:{
    ...mapState("global", ["navigatorInfo","currentTap"]),
  },
  methods:{
    ...mapActions("global", ["ActionSetCurrentTap"]),
    openPrivate(){
      let url = this.$router.resolve({
         name: "netprivate"
        
       });
       this.$PageUtil.openNewPage(this,url.href)
    },
    getScrollTop(){
      let scrolltop = 0;
      if(document.documentElement && document.documentElement.scrollTop){
        scrolltop = document.documentElement.scrollTop;
      }else if(document.body){
         scrolltop = document.body.scrollTop;
      }
      return scrolltop;
    },
    scrolling(){
      let _this = this;
      window.onscroll = function(){
        _this.tHeight = _this.getScrollTop();
        if(_this.tHeight > 2 * _this.offsetHeight){
          _this.isShowTop = true;
        }else{
          _this.isShowTop = false;
        }
      }
    },
    headerClick(pageName){
      this.ActionSetCurrentTap(pageName);
      this.$router.push(pageName);
    },
    openNetWrite(){
      window.open("/iksnet_api/images/10-1P62FF009231.jpg")
    },
    openPlice(){
      window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025727")
    },
    openNetAcc(){
      window.open("/iksnet_api/images/10-1P62FA341357.jpg")
    },
    openICP(){
      window.open("https://beian.miit.gov.cn/")
    },
    openLink(url){
      window.open(url,'_blank')
    },
    openAccept(){
      window.open("https://ss.knet.cn/verifyseal.dll?sn=e13111511010043456nq0k000000&ct=df&a=1&pa=0.028054921654984355",'_blank')
    },
    goTop(){
      this.$emit("gotoBody");
    },
    toHome(){
      this.$router.push({name:'main'})
    }
  },
  watch:{
    
  },
  mounted(){
    this.offsetHeight = document.documentElement.clientHeight;
    let _this = this;
    document.addEventListener('click', ()=>{
      _this.showWX = false;
    })
    setTimeout(()=>{
      window.addEventListener("scroll", this.scrolling)
    },300)
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrolling);
  },
}
</script>

<style lang="less"> 
    
</style>
